import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants";

const translation = {
  consentModal: {
    title: "Aviso sobre ficheiros cookie",
    description:
      "Utilizamos ficheiros cookie essenciais para garantir que este website funciona corretamente. Também usamos ficheiros cookie opcionais de rastreamento para nos ajudar a compreender como interage com o nosso site. Estes ficheiros cookie opcionais só serão ativados com o seu consentimento.",
    acceptAllBtn: "Aceitar todos",
    acceptNecessaryBtn: "Rejeitar todos",
    showPreferencesBtn: "Gerir preferências individuais",
  },
  preferencesModal: {
    title: "Gerir preferências de ficheiros cookie",
    acceptAllBtn: "Aceitar todos",
    acceptNecessaryBtn: "Rejeitar todos",
    savePreferencesBtn: "Aceitar seleção atual",
    closeIconLabel: "Fechar janela",
    sections: [
      {
        title: "Utilização de ficheiros cookie",
        description:
          "Usamos ficheiros cookie para suportar as funções essenciais deste website e para melhorar a sua experiência de navegação.",
      },
      {
        title: "Ficheiros cookie estritamente necessários",
        description:
          "Estes ficheiros cookie são essenciais para o bom funcionamento do website, por exemplo para a autenticação do utilizador.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Nome",
            domain: "Serviço",
            description: "Descrição",
            expiration: "Expiração",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Ficheiro cookie definido pela Plataforma Comunitária Digital para autenticação do utilizador.",
              expiration: "Sessão",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Ficheiro cookie definido pela Plataforma Comunitária Digital para autenticação do utilizador",
              expiration: "Sessão",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Este ficheiro cookie é utilizado para distinguir entre humanos e bots, protegendo o website contra abusos automáticos. Nenhum dado pessoal é recolhido.",
              expiration: "30 minutos",
            },
          ],
        },
      },
      {
        title: "Analítica",
        description:
          "Os ficheiros cookie usados para a analítica ajudam a recolher dados que permitem aos serviços compreender como os utilizadores interagem com um serviço específico. Estes dados permitem melhorar o conteúdo e criar melhores funcionalidades, melhorando a experiência do utilizador.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Nome",
            domain: "Serviço",
            description: "Descrição",
            expiration: "Expiração",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Ficheiro cookie definido por <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Expira após 12 dias",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Ficheiro cookie definido por <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Sessão",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Permite o armazenamento relacionado com a analítica, por exemplo, duração da visita.";

export { translation, servicesLabel };
